// const PopupIcon = '/assets/bahia/gallery/gallery5.jpg';
// HomeScreen
const PhoneIcon = '/assets/busesahumada/Home/BusesAhumada-Website-Home-Header-Telephone.svg';
const LocationIcon = '/assets/bahia/General/BahiaAzul-Website-LocationIcon.svg';
const HeaderLogo = '/assets/bahia/General/BahiaAzul-Website-Header-Logo.svg';
const FooterLogo = '/assets/bahia/General/BahiaAzul-Website-Footer-Logo.svg';
const kuposLogo = '/assets/bahia/General/BahiaAzul-Website-Footer-kuposLogo.svg';
const BottomFooterKuposLogo = '/assets/bahia/General/BahiaAzul-Website-Footer-kuposLogo.svg';

const BookingActive =
  '/assets/bahia/Home/BahiaAzul-Website-Home-SearchBar-BuyTicketIcon-Active.svg';
const BookingInActive = '/assets/bahia/Home/BahiaAzul-Website-Home-SearchBar-BuyTicketIcon.svg';
const CancelActive =
  '/assets/bahia/Home/BahiaAzul-Website-Home-SearchBar-CancelTicketIcon-active.svg';
const CancelInActive = '/assets/bahia/Home/BahiaAzul-Website-Home-SearchBar-CancelTicketIcon.svg';

const OriginIcon = '/assets/thaebus/Home/BusesAhumada-Website-Home-SearchBar-OriginIcon.svg';
const DestinationIcon =
  '/assets/thaebus/Home/BusesAhumada-Website-Home-SearchBar-DestinationIcon.svg';
const CalendarIcon =
  '/assets/busesahumada/Home/BusesAhumada-Website-Home-SearchBar-CalendarIcon.svg';
const SearchIcon = '/assets/thaebus/Home/SearchBar-SearchIcon.svg';
const pnr = '/assets/thaebus/Home/Thaebus-Website-WhereToFindMyPNR.jpg';

const service1 = '/assets/thaebus/Home/Thaebus-Website-Home-Services1.png';
const service2 = '/assets/thaebus/Home/Thaebus-Website-Home-Services2.png';

const precaution1 = '/assets/thaebus/Home/Thaebus-Website-Home-CovidPrevention1.svg';
const precaution2 = '/assets/thaebus/Home/Thaebus-Website-Home-CovidPrevention2.svg';
const precaution3 = '/assets/thaebus/Home/Thaebus-Website-Home-CovidPrevention3.svg';
const precaution4 = '/assets/thaebus/Home/Thaebus-Website-Home-CovidPrevention4.svg';

const companyBG = '/assets/thaebus/Home/Thaebus-Website-Home-BackgroundImage.png';
const companyVideo = '/assets/thaebus/Home/BusesAhumada-Home-Video-COVID19-PopUp.mp4';

const ContactBg = '/assets/bahia/Home/BahiaAzul-Website-Home-Banner-ContactSection.jpg';

const checkboxIcon = '/assets/bahia/ResultpageCheck-Out/BusOperatorsWebsite-Checkbox.png';

// services list
const animation = '/assets/bahia/ResultpageCheck-Out/Services-kupos-PasajeBus.gif';

// Contact Screen
const contactLocation = '/assets/busesahumada/Home/BusesAhumada-Website-Home-Footer-Contact3.svg';
const contactMail = '/assets/busesahumada/Home/BusesAhumada-Website-Home-Footer-Contact2.svg';
const contactHeadphone = '/assets/busesahumada/Home/BusesAhumada-Website-Home-Footer-Contact1.svg';

const contactLocationBlue = '/assets/thaebus/Contact/Thaebus-Website-Contact-1.svg';
const contactMailBlue = '/assets/thaebus/Contact/Thaebus-Website-Contact-2.svg';
const contactHeadphoneBlue = '/assets/thaebus/Contact/Thaebus-Website-Contact-3.svg';

// About us Screen
const aboutUsImage = '/assets/bahia/AboutUs/BahiaAzul-Website-AboutUs-Image2.jpg';

// Main banners
const destinationBanner =
  '/assets/bahia/Destinations/BahiaAzul-Website-MainBanner-Destinations.jpg';
const frequentPassengerBanner = '/assets/busesahumada/General/BusesAhumada-Website-FrequentPassenger-Banner.jpg';
const specialServiceBanner = '/assets/busesahumada/General/BusesAhumada-Website-SpecialServices-Banner.jpg';
const contactUsBanner = '/assets/thaebus/Contact/Thaebus-Website-Contact-Banner.jpg';
const aboutUsBanner = '/assets/thaebus/AboutUs/Thaebus-Website-Company-Banner.jpg';
const tncMendozaBanner =
  '/assets/busesahumada/TnC/BusesAhumada-Website-TermsAndConditions-Mendoza-Banner.jpg';
const tncRegulationBanner =
  '/assets/busesahumada/TnC/BusesAhumada-Website-TermsAndConditions-Rules-Banner.jpg';
const tncBaggageBanner =
  '/assets/busesahumada/TnC/BusesAhumada-Website-TermsAndConditions-Baggage-Banner.jpg';
const officeBanner = '/assets/thaebus/Offices/Thaebus-Website-Offices-Banner.jpg';
const workWithUsBanner =
  '/assets/thaebus/WorkWithus/Thaebus-Website-Work-With-Us.jpg';

const tncBanner = '/assets/thaebus/TnC/Thaebus-Website-TermsConditions-Banner.jpg';

const OfficePhoneIcon = '/assets/bahia/General/BahiaAzul-Website-PhoneIcon-dark.svg';
// const OfficePhoneIconDark = '/assets/bahia/General/BahiaAzul-Website-PhoneIcon-dark.svg';

const userIcon = '/assets/bahia/Home/user_red_dot-BahiaAzul.svg';
const trips = '/assets/bahia/Blue/MyAccount-IllustratedIcons-MyTrips-Blue.svg';
const cards = '/assets/bahia/Blue/MyAccount-IllustratedIcons-MyCards-Blue.svg';
const wallet = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const transaction = '/assets/bahia/Blue/MyAccount-IllustratedIcons-ShareMoney-Blue.svg';

const paso_1 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const paso_2 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RechargePoints-Blue.svg';
const paso_3 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-ID-Blue.svg';
const paso_4 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Tickets-Blue.svg';

const success = '/assets/bahia/Blue/MyAccount-IllustratedIcons-CheckMark-Blue.svg';
const failure = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Information-Blue.svg';

const tick = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Tick-Blue.svg';
const heartOn = '/assets/bahia/Blue/MyAccount-IllustratedIcons-HeartOn-Blue.svg';
const heartOff = '/assets/bahia/Blue/MyAccount-IllustratedIcons-HeartOff-Blue.svg';
const downArrow = '/assets/bahia/Blue/MyAccount-IllustratedIcons-DropDown-Blue.svg';
const registrationSuccess = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RightDocument-Blue.svg';

const otp = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RestorePassword-Blue.svg';

const studentBanner = '/assets/busesahumada/Home/BusesAhumada-Website-Home-Banner-Students.jpg';
const cvAttached = '/assets/busesahumada/WorkWithus/BusesAhumada-Website-WorkWithUs-CVAttached.svg';
const baggageMinus =
  '/assets/busesahumada/TnC/BusesAhumada-Website-TermsAndConditions-Baggage-Minus.svg';
const baggagePlus =
  '/assets/busesahumada/TnC/BusesAhumada-Website-TermsAndConditions-Baggage-Plus.svg';

const office1 = '/assets/thaebus/Offices/Thaebus-Website-Offices-CasaMatriz.png';
const office2 = '/assets/thaebus/Offices/Thaebus-Website-Offices-Santiago.png';
const office3 = '/assets/thaebus/Offices/Thaebus-Website-Offices-PuertoMontt.png';
const office4 = '/assets/thaebus/Offices/Thaebus-Website-Offices-Osorno.png';

const busesahumadaIcons = [
  { icon: PhoneIcon, name: 'phone' },
  { icon: LocationIcon, name: 'location' },
  { icon: HeaderLogo, name: 'headerLogo' },
  { icon: FooterLogo, name: 'footerLogo' },
  { icon: kuposLogo, name: 'kupos' },
  { icon: registrationSuccess, name: 'registrationSuccess' },
  { icon: studentBanner, name: 'studentBanner' },

  { icon: service1, name: 'service1' },
  { icon: service2, name: 'service2' },

  { icon: office1, name: 'office1' },
  { icon: office2, name: 'office2' },
  { icon: office3, name: 'office3' },
  { icon: office4, name: 'office4' },

  { icon: baggageMinus, name: 'baggageMinus' },
  { icon: baggagePlus, name: 'baggagePlus' },

  { icon: precaution1, name: 'precaution1' },
  { icon: precaution2, name: 'precaution2' },
  { icon: precaution3, name: 'precaution3' },
  { icon: precaution4, name: 'precaution4' },

  { icon: companyBG, name: 'companyBG' },
  { icon: companyVideo, name: 'companyVideo' },

  { icon: downArrow, name: 'downArrow' },
  { icon: userIcon, name: 'userIcon' },
  { icon: trips, name: 'trips' },
  { icon: cards, name: 'cards' },
  { icon: wallet, name: 'wallet' },
  { icon: transaction, name: 'transaction' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: tick, name: 'tick' },
  { icon: heartOn, name: 'heartOn' },
  { icon: heartOff, name: 'heartOff' },
  { icon: otp, name: 'otp' },

  { icon: paso_1, name: 'paso_1' },
  { icon: paso_2, name: 'paso_2' },
  { icon: paso_3, name: 'paso_3' },
  { icon: paso_4, name: 'paso_4' },

  { icon: ContactBg, name: 'ContactBg' },
  { icon: BookingInActive, name: 'BIA' },
  { icon: BookingInActive, name: 'BA' },
  { icon: CancelInActive, name: 'CIA' },
  { icon: CancelInActive, name: 'CA' },
  { icon: OriginIcon, name: 'Origin' },
  { icon: DestinationIcon, name: 'Destination' },
  { icon: CalendarIcon, name: 'Calendar' },
  { icon: SearchIcon, name: 'Search' },
  // { icon: PopupIcon, name: 'Popup' },
  { icon: checkboxIcon, name: 'Checkbox' },
  { icon: BottomFooterKuposLogo, name: 'BottomFooterKuposLogo' },
  { icon: animation, name: 'animation' },
  { icon: pnr, name: 'pnr' },
  { icon: OfficePhoneIcon, name: 'OfficePhoneIcon' },

  { icon: contactMail, name: 'contactMail' },
  { icon: contactHeadphone, name: 'contactHeadphone' },
  { icon: contactLocation, name: 'contactLocation' },

  { icon: contactMailBlue, name: 'contactMailBlue' },
  { icon: contactHeadphoneBlue, name: 'contactHeadphoneBlue' },
  { icon: contactLocationBlue, name: 'contactLocationBlue' },

  { icon: destinationBanner, name: 'destinationBanner' },
  { icon: frequentPassengerBanner, name: 'frequentPassengerBanner' },
  { icon: specialServiceBanner, name: 'specialServiceBanner' },
  { icon: contactUsBanner, name: 'contactUsBanner' },
  { icon: aboutUsImage, name: 'aboutUsImage' },
  { icon: aboutUsBanner, name: 'aboutUsBanner' },
  { icon: tncMendozaBanner, name: 'tncMendozaBanner' },
  { icon: tncRegulationBanner, name: 'tncRegulationBanner' },
  { icon: tncBaggageBanner, name: 'tncBaggageBanner' },
  { icon: officeBanner, name: 'officeBanner' },
  { icon: workWithUsBanner, name: 'workWithUsBanner' },
  { icon: cvAttached, name: 'cvAttached' },
  { icon: tncBanner, name: 'tncBanner' },
];

export default busesahumadaIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/thaebusIcons.js